import { fetchJson } from 'utils/fetch';

export const fetchTemplates = () => fetchJson('/flow/templates.json');



// WEBPACK FOOTER //
// ./src/modules/edito/api/index.js